module.exports = __webpack_public_path__ + "static/media/logo-mirandiba.89066051.png";